export const randArrayValueByString = (array: any[], str: string) => {
  let number: any = 0;
  const length = str.length;
  for (let i = 0; i < length; i++) number += str.charCodeAt(i);
  return array[number % array.length];
};
